module.exports = __webpack_public_path__ + "static/img/吴永浩B.09cec724.png";